<div class="food-card-container" *ngIf="food" (click)="stoplist ? null : onCardClicked(); $event.stopPropagation()">
  <mat-card class="food-card">
    <div class="image-container">
      <app-lazy-image class="food-card-image" mat-card-image [class.stop-list]="stoplist" kind="food"
        [imageUrl]="food.image"
      ></app-lazy-image>
      <!-- Продуктовые баннеры -->
      <div class="banners" [class.stop-list]="stoplist">
        <app-label-banners [labels]="food.labels"></app-label-banners>
      </div>

      <!-- Служебные баннеры -->
      <div class="info-banner">
        <span class="stoplist-banner" *ngIf="stoplist">{{ 'soldout' | translate }}</span>
      </div>

      <!-- Аллергены: в стоп-листе не показываются (заказать нельзя, место у «Закончилось») -->
      <app-allergen-pill class="allergen-pill" *ngIf="!stoplist" [allergens]="food.allergens"></app-allergen-pill>
    </div>

    <mat-card-content class="food-info" [class.stop-list]="stoplist">
      <div class="food-info__title">
        <div class="food-title" [innerHTML]="title"></div>
      </div>

      <!-- Price -->
      <mat-card-title class="food-info__price" [class.stop-list]="stoplist" *ngIf="food.price as value">
        <ng-container *ngIf="value | priceSeparator as separated">
          <span *ngIf="food.variability" class="food-price__from">{{ 'from' | translate }} </span>
          <span class="food-price__whole">{{ separated.whole }}</span>
          <span class="food-price__dot">{{ separated.separator }}</span>
          <span class="food-price__fraction">{{ separated.fraction }}</span>
          <span class="food-price__currency">{{ locale?.currency }}</span>
        </ng-container>
        
        <!-- Size -->
        <span class="food-size" [class.stop-list]="stoplist" *ngIf="food.size && !basketFood">
          {{ food.size }} {{ locale?.units?.get(food.unit) }}
        </span>
      </mat-card-title>

      <div class="food-info__count" *ngIf="basketFood">
        <img src="assets/basket.svg" alt="basket" class="food-basket-icon" />
        <span class="food-count">{{ basketFood.count }}</span>
      </div>

    </mat-card-content>
  </mat-card>
</div>